import { IFollowUpArea } from 'api-paths-cas';

export default function getRequestNewDocumentDefaultValue(data: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  docs: any;
  sponsorType: string | null;
  sponsorKey: string | null;
  docType: string | null;
  docKey: string | null;
}) {
  const { docs, sponsorType, sponsorKey, docType, docKey } = data;

  let allDocsOfType;
  if (sponsorType && sponsorKey && docType && docKey) {
    if ([IFollowUpArea.BEFORE_TRAVEL, IFollowUpArea.AFTER_ARRIVAL].includes(sponsorType as IFollowUpArea)) {
      // follow-up custom docs
      allDocsOfType = docs[sponsorType][docType][sponsorKey];
    } else {
      allDocsOfType = docs[sponsorType][sponsorKey][docType];
    }
  } else if (sponsorType && docType === null && sponsorKey === null && docKey) {
    allDocsOfType = docs[sponsorType];
  } else if (sponsorType && docType === null && sponsorKey && docKey) {
    allDocsOfType = docs[sponsorType][sponsorKey];
  } else if (sponsorType === null && sponsorKey === null && docType && docKey) {
    allDocsOfType = docs[docType];
  } else if (sponsorType && sponsorKey === null && docType && docKey) {
    allDocsOfType = docs[sponsorType][docType];
  }

  if (!docKey) return true;

  const currentDocNumber = getDocNumber(docKey);

  for (const key in allDocsOfType) {
    const docNumber = getDocNumber(key);
    if (docNumber > currentDocNumber) {
      return false;
    }
  }

  return true;
}

const getDocNumber = (docKey: string) => {
  const arr = docKey.split('-');
  return arr[arr.length - 1];
};
